/**
 * PDP color swatch AJAX handler
 * Handles clicking color swatches to load different products without page reload.
 */

/**
 * Re-executes inline scripts within an element.
 * When HTML is inserted via innerHTML/replaceWith, scripts don't execute.
 */
function executeScripts(element) {
  element.querySelectorAll('script:not([src])').forEach((oldScript) => {
    const newScript = document.createElement('script');
    Array.from(oldScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value);
    });
    newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

document.addEventListener('click', async (event) => {
  const swatchButton = event.target.closest('.color_wrapper-PDP .pdp-swatch-button[data-product-url]');
  if (!swatchButton) return;
  if (swatchButton.closest('quick-add-modal')) return;

  // Skip if this swatch is already selected (active)
  if (swatchButton.classList.contains('active')) return;

  const productUrl = swatchButton.dataset.productUrl;

  const section = document.querySelector('section[id^="MainProduct-"]');
  if (!section) {
    window.location.href = productUrl;
    return;
  }

  // Show loading state
  section.style.opacity = '0.5';
  section.style.pointerEvents = 'none';

  const sectionId = section.id.replace('MainProduct-', '');

  try {
    const response = await fetch(`${productUrl}?section_id=${sectionId}`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newSection = doc.querySelector('section[id^="MainProduct-"]');

    if (!newSection) throw new Error('Main product section not found');

    section.replaceWith(newSection);
    history.replaceState({}, '', productUrl);

    // Re-execute inline scripts (for Taly, etc.)
    executeScripts(newSection);

    // On desktop the new product may have fewer images, so reset to the top of the section
    if (window.matchMedia('(min-width: 750px)').matches) {
      const headerHeight = document.querySelector('.sticky-header')?.offsetHeight || 0;
      window.scrollTo({ top: newSection.offsetTop - headerHeight, behavior: 'smooth' });
    }

    // Reinitialize Shopify payment buttons
    window.Shopify?.PaymentButton?.init();

  } catch (error) {
    console.error('Color swatch AJAX error:', error);
    window.location.href = productUrl;
  }
});
